/**
 * Debug utility to help diagnose API URL issues
 */

export function debugApiUrl() {
  // Get the API URL from environment variables
  const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:3000/api';
  
  // Get the current host
  const currentHost = window.location.origin;
  
  // Display relevant information
  console.log('🔍 API URL Debugging Information:');
  console.log('🌐 Environment API URL:', apiUrl);
  console.log('📍 Current location:', window.location.href);
  console.log('🏠 Current host:', currentHost);
  
  // Check if there's a potential CORS issue (only for absolute URLs)
  let apiHost = currentHost; // Default for relative URLs
  let potentialCorsIssue = false;
  
  try {
    if (!apiUrl.startsWith('/')) {
      // Only create URL object for absolute URLs
      const apiUrlObj = new URL(apiUrl);
      apiHost = apiUrlObj.origin;
      
      if (currentHost !== apiHost) {
        console.warn('⚠️ Potential CORS issue detected!');
        console.warn('   App is running on', currentHost);
        console.warn('   But trying to connect to API at', apiHost);
        console.warn('   Make sure CORS is properly configured on the server');
        console.warn('   Or ensure the API URL matches the current host');
        potentialCorsIssue = true;
      } else {
        console.log('✅ Same-origin request - No CORS issues expected');
      }
    } else {
      console.log('✅ Using relative URL - Same-origin request guaranteed');
    }
  } catch (error) {
    console.warn('⚠️ Could not parse API URL:', apiUrl);
  }
  
  return {
    apiUrl,
    currentHost,
    apiHost,
    potentialCorsIssue
  };
}

export function fixApiUrlForProduction() {
  const envApiUrl = import.meta.env.VITE_API_URL || 'http://localhost:3000/api';
  
  // In production, if no VITE_API_URL is set, use current origin + /api
  if (!import.meta.env.VITE_API_URL && window.location.hostname !== 'localhost') {
    const productionUrl = window.location.origin + '/api';
    console.log('🏭 Production mode - Using origin + /api:', productionUrl);
    return productionUrl;
  }
  
  // If the API URL is relative (starts with /), make it absolute using current host
  if (envApiUrl.startsWith('/')) {
    const currentHost = window.location.origin;
    const absoluteUrl = currentHost + envApiUrl;
    console.log('🔄 Converting relative API URL to absolute:', absoluteUrl);
    return absoluteUrl;
  }
  
  // If it's already absolute, use as-is (for development)
  console.log('🔗 Using configured API URL:', envApiUrl);
  return envApiUrl;
}